export default __webpack_public_path__ + "static/media/commercial.753d8bea.jpg";